<template>
  <ul
    v-if="items.length"
    class="list-unstyled adjuntos-guardados mb-0"
    :class="{
      'mt-1': compacto,
      'mt-2': !compacto,
      'adjuntos-guardados-claro': tono === 'claro',
      'adjuntos-solo-icono': soloIcono,
    }"
  >
    <li
      v-for="(adjunto, index) in items"
      :key="(adjunto.id || adjunto.link || 'adj') + '-' + index"
    >
      <a
        :href="urlAdjuntoGuardado(adjunto)"
        target="_blank"
        rel="noopener noreferrer"
        class="d-inline-flex align-items-center"
        :title="soloIcono ? null : nombreAdjuntoGuardado(adjunto)"
        :data-nombre="nombreAdjuntoGuardado(adjunto)"
      >
        <i
          :class="[
            iconoAdjuntoPorNombre(nombreAdjuntoGuardado(adjunto)),
            { 'mr-1': !soloIcono },
          ]"
        ></i>
        <span v-if="!soloIcono" class="text-truncate">
          {{ nombreAdjuntoGuardado(adjunto) }}
        </span>
      </a>
    </li>
  </ul>
</template>

<script>
import {
  iconoAdjuntoPorNombre,
  nombreAdjuntoGuardado,
  urlAdjuntoGuardado,
} from "./adjuntosTicket";

export default {
  name: "AdjuntosTicketLinks",

  props: {
    adjuntos: {
      type: Array,
      default: () => [],
    },
    compacto: {
      type: Boolean,
      default: true,
    },
    tono: {
      type: String,
      default: "normal",
    },
    soloIcono: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    items() {
      return (this.adjuntos || []).filter(
        (adjunto) => adjunto && (adjunto.url || adjunto.link)
      );
    },
  },

  methods: {
    iconoAdjuntoPorNombre,
    nombreAdjuntoGuardado,
    urlAdjuntoGuardado,
  },
};
</script>

<style scoped>
.adjuntos-guardados {
  font-size: 0.8rem;
}

.adjuntos-guardados a {
  max-width: 100%;
  color: inherit;
  text-decoration: underline;
}

.adjuntos-guardados li + li {
  margin-top: 0.1rem;
}

.adjuntos-guardados-claro {
  display: flex;
  flex-wrap: wrap;
}

.adjuntos-guardados-claro li {
  margin: 0 0.25rem 0.25rem 0;
}

.adjuntos-guardados-claro li + li {
  margin-top: 0;
}

.adjuntos-guardados-claro a {
  color: #1a2e0a;
  background: #bad35c;
  text-decoration: none;
  border-radius: 999px;
  padding: 0.05rem 0.5rem;
  line-height: 1.35;
  max-width: 14rem;
}

.adjuntos-solo-icono {
  display: flex;
  flex-wrap: wrap;
  overflow: visible;
}

.adjuntos-solo-icono li {
  position: relative;
  z-index: 1;
  margin: 0 0.4rem 0 0;
}

.adjuntos-solo-icono li:hover {
  z-index: 8;
}

.adjuntos-solo-icono li + li {
  margin-top: 0;
}

.adjuntos-solo-icono a {
  position: relative;
  width: auto;
  height: auto;
  justify-content: center;
  padding: 0;
  max-width: none;
  background: none;
  border-radius: 0;
  color: #bad35c;
  text-decoration: none;
  font-size: 0.85rem;
  line-height: 1;
}

.adjuntos-solo-icono a:hover {
  color: #fff;
}
</style>
<style>
/* Sin scoped: el ::after no recibe data-v y Vue 2 lo deja fuera del selector. */
.adjuntos-solo-icono a:hover::after {
  content: attr(data-nombre);
  position: absolute;
  left: 50%;
  bottom: calc(100% + 0.25rem);
  top: auto;
  z-index: 30;
  transform: translateX(-50%);
  background: #0b1220;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  padding: 0.15rem 0.4rem;
  border-radius: 0.2rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  pointer-events: none;
}
</style>
